<template>
  <div class="bg-light">
    <!-- Header -->
    <Header></Header>

    <!-- Main Content -->
    <main class="container my-4">
      <div class="row">
        <div class="col-lg-12 mb-4">
          <div class="bg-white rounded-lg shadow-lg p-4">
            <h3 class="font-weight-bold mb-4 text-zebra text-start">
              <strong>Confirmación de Pago</strong>
            </h3>
            <p>¿Desea seguir con el pago para la transacción con ID: {{ transactionId }}?</p>
            <div class="d-flex justify-content-end gap-2">
              <button class="btn btn-secondary" @click="cancelPayment">
                Cancelar
              </button>
              <button class="btn btn-zebra" @click="confirmPayment">
                Confirmar
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { ref } from 'vue';
import Swal from 'sweetalert2';

export default {
  name: 'ConfirmarPago',
  props: {
    transactionId: {
      type: String,
      required: true
    }
  },
  setup() {
    const showModal = ref(false);
    return {
      showModal
    };
  },
  mounted() {
    const id = this.$route.params.transactionId || this.$route.query.transactionId;
    this.getTransations(id);
  },
  methods: {
    cancelPayment() {
      Swal.fire({
        title: 'Pago Cancelado',
        text: 'La transacción ha sido cancelada.',
        icon: 'info',
        confirmButtonText: 'Ok'
      }).then(() => {
        this.$router.push('/');
      });
    },

    async getTransations(id) {        
        this.$root.getTransaction(id).then(transaction => {
            if (transaction.status == "ERROR") {
            // Swal.fire({
            //     title: 'Error',
            //     text: transaction.error.message,
            //     icon: 'error',
            //     confirmButtonText: 'Ok'
            // });
            } else {
                if (transaction.data.payment_method.type == 'BANCOLOMBIA_TRANSFER' || transaction.data.payment_method.type ==  'PSE') {
                    if (transaction.data.payment_method.extra.async_payment_url) {
                        window.location.href = transaction.data.payment_method.extra.async_payment_url;
                    } else {
                    this.getTransations(id);
                    }
                }
            }
        });
    },
    confirmPayment() {
      Swal.fire({
        title: 'Pago Confirmado',
        text: 'La transacción ha sido confirmada.',
        icon: 'success',
        confirmButtonText: 'Ok'
      }).then(() => {
        // Aquí puedes agregar la lógica para procesar el pago
        this.$router.push('/');
      });
    }
  }
};
</script>

<style scoped>
.bg-light {
  background-color: #f8f9fa;
}

.btn-zebra {
  background-color: #20c997;
  color: white;
}

.btn-zebra:hover {
  background-color: #17a2b8;
}

.text-zebra {
  color: #20c997;
}
</style>
